module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-05-30 at 2.21.53 PM.8e9cfa93.png";